import { Loader2 } from "lucide-react";
export function BillExtractionProgress({ extraction }: { extraction: any }) {
  if (extraction?.status !== "processing") return null;
  const completed = Number(extraction.progress?.completedPages ?? 0);
  const total = Number(extraction.progress?.totalPages ?? 0);
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-w-0 items-start gap-2 rounded-lg bg-muted/40 p-3 text-sm"
    >
      <Loader2
        aria-hidden="true"
        className="mt-0.5 h-4 w-4 shrink-0 animate-spin"
      />
      <div className="min-w-0">
        <p className="font-medium">
          Lectura en curso
          {total > 0 ? ` · ${completed} de ${total} páginas completadas` : ""}
        </p>
        <p className="text-muted-foreground">
          El original está guardado. Puedes salir y volver: conservaremos el
          avance. Las propuestas aparecerán al terminar toda la factura.
        </p>
      </div>
    </div>
  );
}
export const billProgressRefetchInterval = (query: any) => {
  const documents = query?.state?.data;
  if (!Array.isArray(documents)) return false;

  return documents.some(
    (document: any) => document.extraction?.status === "processing"
  )
    ? 2000
    : false;
};
